import axios from "axios";

const placeNewOrder = async (order, token) => {
  try {
    return axios.post(`/api/orders`, order, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  } catch (error) {
    console.error(`Error placing new order: ${error}`);
  }
};

const getUserOrders = async (token, maxOrders = 20) => {
  try {
    const result = await axios.get(`/api/orders`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: {
        limit: maxOrders,
      },
    });

    return result.data;
  } catch (error) {
    console.error(`Error getting user orders: ${error}`);
  }
};

const getBannerOptions = async (token, insuranceCompany) => {
  try {
    const result = await axios.get(`/api/orders/banner-options`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: {
        insuranceCompany,
      },
    });

    return result.data;
  } catch (error) {
    console.error(`Error getting banner options: ${error}`);
    // Return default banner options as fallback
    return [
      "Amex",
      "Aura",
      "Diners",
      "Discover",
      "Elo",
      "Hiper",
      "Hipercard",
      "JCB",
      "MasterCard",
      "Visa",
    ];
  }
};

const cancelOrder = async (orderId, token) => {
  return axios.put(
    `/api/orders/${orderId}/cancel`,
    {},
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};

export { placeNewOrder, getUserOrders, getBannerOptions, cancelOrder };
